import { useTheme } from "../styles/theme";

export default function FlowRow({ icon, label, value, color, sub }) {
  const S = useTheme();
  return (
    <div style={S.flowRow}>
      <span style={S.flowIcon}>{icon}</span>
      <span style={S.flowLabel}>{label}</span>
      {sub && <span style={S.flowSub}>{sub}</span>}
      <span style={{ ...S.flowValue, color }}>{value}</span>
    </div>
  );
}
